import { APP_INITIALIZER, Provider } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { initializeLinkTags } from '@qaroni-core/utils/scripts/link-tags';
import { initializeMetaTags } from '@qaroni-core/utils/scripts/meta-tags';
import { initializeMapScript } from '@qaroni-core/utils/scripts/script-map';

export const provideInitialize = (): Provider[] => {
  return [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeLinkTags,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeMetaTags,
      deps: [Meta],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeMapScript,
      multi: true,
    },
  ];
};
